"use client";

import Link from "next/link";
import classes from "./MorePopup.module.scss";
import LinkedIn from "@/assets/icons/LinkedIn";
import X from "@/assets/icons/X";
import useIsMobile from "@/hooks/useIsMobile";
import Arrow from "@/assets/icons/Arrow";
import { useState } from "react";
import headerLinks from "../config/headerLinks";
import { useRouter } from "next/navigation";

const cbsLinksArr1 = [
  {
    title: "AI Events",
    link: "/category/ai-events",
  },
  {
    title: "Announcements",
    link: "/announcements",
  },
];

const companyLinksArr = [
  {
    title: "About Us",
    link: "/about-us",
  },
  {
    title: "Contact Us",
    link: "/contact",
  },
];

const moreOptionsArr = [
  {
    title: "Content by Subject",
    options: [...cbsLinksArr1],
  },
  { title: "Company", options: [...companyLinksArr] },
];

interface MorePopupProps {
  setMoreVisbility: (visible: boolean) => void;
}

const MorePopup: React.FC<MorePopupProps> = ({ setMoreVisbility }) => {
  const isMobile = useIsMobile(600);
  const [activeDropdown, setActiveDropdown] = useState("");

  const router = useRouter();

  const readMoreClick = () => {
    setMoreVisbility(false);
  };

  return (
    <>
      {isMobile ? (
        <div className={classes["more-popup-container"]}>
          <div className={classes["more-popup-container-content"]}>
            {headerLinks.map((el, index) => (
              <div key={index} className={classes["option-container"]}>
                <div
                  className={classes["option"]}
                  onClick={() => {
                    if (el.isDropdown) {
                      if (el.title == activeDropdown) {
                        setActiveDropdown("");
                      } else {
                        setActiveDropdown(el.title);
                      }
                    } else {
                      router.push(el.link);
                      readMoreClick();
                    }
                  }}
                >
                  {el.title}{" "}
                  {el.isDropdown && (
                    <div
                      className={
                        el.title === activeDropdown
                          ? `${classes["arrow-container"]} ${classes["arrow-container-active"]}`
                          : classes["arrow-container"]
                      }
                    >
                      {el.title === activeDropdown ? (
                        <Arrow color="black" rotation={180} />
                      ) : (
                        <Arrow color="black" />
                      )}
                    </div>
                  )}{" "}
                </div>

                <div className={classes["separator"]}></div>
                {el.isDropdown && el.title === activeDropdown && (
                  <div className={classes["sub-dropdown-option-container"]}>
                    {el.option.map(({ title, link }, index) => (
                      <Link
                        key={index}
                        href={link}
                        className={classes["link"]}
                        onClick={readMoreClick}
                      >
                        {title}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
            <div className={classes["more-container"]}>
              <div
                className={classes["option-more"]}
                onClick={() => {
                  if (activeDropdown === "More") {
                    setActiveDropdown("");
                  } else {
                    setActiveDropdown("More");
                  }
                }}
              >
                More{" "}
                <div
                  className={
                    activeDropdown === "More"
                      ? `${classes["arrow-container"]} ${classes["arrow-container-active"]}`
                      : classes["arrow-container"]
                  }
                >
                  {activeDropdown === "More" ? (
                    <Arrow color="black" rotation={180} />
                  ) : (
                    <Arrow color="black" />
                  )}
                </div>
              </div>

              <div className={classes["separator"]}></div>

              {activeDropdown === "More" && (
                <div className={classes["sub-dropdown-option-container"]}>
                  {moreOptionsArr.map((subEl, index) => (
                    <div key={index}>
                      <div className={classes["sub-option"]}>{subEl.title}</div>
                      <div className={classes["separator"]}></div>
                      <div
                        className={
                          classes["sub-child-dropdown-option-container"]
                        }
                      >
                        {subEl.options.map(({ title, link }, index) => (
                          <Link key={index} href={link} onClick={readMoreClick}>
                            <div className={classes["sub-child-option"]}>
                              {title}
                            </div>
                          </Link>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className={classes["more-popup-container"]}>
          <div className={classes["content-by-subject-container"]}>
            <p className={classes["section-title"]}>Content by Subject</p>
            <div className={classes["separator"]}></div>
            <div className={classes["link-list-container"]}>
              <div className={classes["link-list-left-container"]}>
                {cbsLinksArr1.map(({ title, link }, index) => (
                  <Link
                    key={index}
                    href={link}
                    className={classes["link"]}
                    onClick={readMoreClick}
                  >
                    {title}
                  </Link>
                ))}
              </div>
              {/* <div className={classes["link-list-right-container"]}>
                {cbsLinksArr2.map(({ title, link }, index) => (
                  <Link
                    key={index}
                    href={link}
                    className={classes["link"]}
                    onClick={readMoreClick}
                  >
                    {title}
                  </Link>
                ))}
              </div> */}
            </div>
          </div>
          <div className={classes["company-container"]}>
            <p className={classes["section-title"]}>Company</p>
            <div className={classes["separator"]}></div>
            <div className={classes["link-list-container"]}>
              {companyLinksArr.map(({ title, link }, index) => (
                <Link
                  key={index}
                  href={link}
                  className={classes["link"]}
                  onClick={readMoreClick}
                >
                  {title}
                </Link>
              ))}
            </div>
          </div>

          <div className={classes["social-media-icons-container"]}>
            <Link
              href={
                "https://www.linkedin.com/company/nextgen-ai-news/about/?viewAsMember=true"
              }
              rel="noopener noreferrer"
              target="_blank"
            >
              <LinkedIn color="#000" />
            </Link>

            <Link
              href={"https://x.com/news_ngai"}
              rel="noopener noreferrer"
              target="_blank"
            >
              <X color="#000" />
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default MorePopup;
